export default __webpack_public_path__ + "static/column-offset-light-300294bd892d3d1f1a09d9b16837272ff23095d554d9b400a27138b20ee06851.png";